import { getConfigWithMetadata } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils/error';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import { getListingById as generatedGetListingById, type GetListingByIdParams, type GetListingResponse } from '@generated/search-bff';

/**
 * Fetch detailed property information by its listing ID (UUID) using the `/api/v2/listing/{listingId}` endpoint.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/listings/getListingById Search API Documentation}
 */
export async function getListingById(
  listingId: string,
  params: GetListingByIdParams,
  apiConfig: ApiConfig,
): Promise<ApiResult<GetListingResponse, GetListingResponse>> {
  const _apiConfig = getConfigWithMetadata(apiConfig, 'getListingById');

  try {
    const listing = await generatedGetListingById(listingId, params, _apiConfig);

    return {
      status: 'success',
      data: listing,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult<GetListingResponse>(error);
  }
}
